import { BaseListParams, PaginationMeta } from '../base.type'
import { User } from '../user'

/**
 * Notification type from API
 */
export type NotificationType =
    | 'task_overdue'
    | 'task_neardue'
    | 'task_assigned'
    | 'task_deadline_changed'
    | 'task_comment'
    | 'new_request_approval'
    | 'request_approval_rejected'
    | 'new_comment'
    | 'role_changed'
    | 'project_item_changed'
    | 'request_approval_reminder'
    | 'weekly_report_created'
    | 'weekly_report_updated'
    | 'subordinate_picked_task_from_other_unit'

export enum NotificationTypeEnum {
    // Task
    TASK_ASSIGNED = 'task_assigned',
    TASK_NEARDUE = 'task_neardue',
    TASK_OVERDUE = 'task_overdue',
    TASK_DEADLINE_CHANGED = 'task_deadline_changed',
    SUBORDINATE_PICKED_TASK_FROM_OTHER_UNIT = 'subordinate_picked_task_from_other_unit',
    // Request approval
    NEW_REQUEST_APPROVAL = 'new_request_approval',
    REQUEST_APPROVAL_REJECTED = 'request_approval_rejected',
    REQUEST_APPROVAL_APPROVED = 'request_approval_approved',
    // Comment
    TASK_COMMENT = 'task_comment', // Bình luận từ assigned user/creator
    NEW_COMMENT = 'new_comment', // Nhận xét từ người phê duyệt
    // Role
    ROLE_CHANGED = 'role_changed',
    // Project / Document / Task changed
    PROJECT_ITEM_CHANGED = 'project_item_changed',
    // Reminder
    REQUEST_APPROVAL_REMINDER = 'request_approval_reminder',
    // Weekly Report
    WEEKLY_REPORT_CREATED = 'weekly_report_created',
    WEEKLY_REPORT_UPDATED = 'weekly_report_updated',
}

/**
 * Notification category from API
 */
export type NotificationCategory = 'general' | 'approval' | 'warning'

/**
 * Notification metadata - varies by notification type
 * - task_assigned: { dueDate, createdBy }
 * - task_overdue/task_neardue: { dueDate }
 * - task_deadline_changed: { dueDate }
 * - task_comment: { createdBy, commentId }
 * - new_request_approval: { approver, requester }
 * - request_approval_rejected: { rejecter, reason }
 * - request_approval_approved: { approver }
 */
export interface NotificationMetadata {
    // Common
    dueDate?: string

    // weekly_report_created
    week?: number
    year?: number
    areaName?: string
    startDate?: string
    endDate?: string

    // task_assigned, task_comment
    createdBy?: {
        id: string
        fullName: string
        avatar?: string
    }

    // task_comment
    commentId?: string

    // new_request_approval
    requester?: string

    // new_request_approval, request_approval_approved
    approver?: string

    // request_approval_rejected
    rejecter?: string
    reason?: string
    requestApprovalId?: string

    // project_item_changed
    requesterName?: string
    action?: string
    itemType?: string
    itemName?: string
    projectName?: string
    projectId?: string
    documentId?: string
    taskId?: string
    itemId?: string

    // request_approval_reminder
    dayCount?: number
}

/**
 * Task info in notification
 */
export interface NotificationTask {
    id: string
    title: string
    taskCode: string
    projectId: string | null
    dueDate: string | null
    isOverdue: boolean
    status: string
    assignedUsers?: User[] | null
}

/**
 * Notification entity
 */
export interface Notification {
    id: string
    createdAt: string
    updatedAt: string
    metadata: NotificationMetadata
    isRead: boolean
    user: User
    requester?: User
    type: NotificationType
    task: NotificationTask | null
    title: string
    content: string
}

/**
 * List notifications response with unReadCount in meta
 */
export interface ListNotificationsResponse {
    data: Notification[]
    meta: PaginationMeta & {
        unReadCount: number
    }
}

/**
 * List notifications params
 */
export type ListNotificationsParams = BaseListParams & {
    requesterIds?: string[]
    isRead?: boolean
}
